import { Heading } from '@chakra-ui/react'
import React from 'react'

function CardHeading({ children }) {
  return (
    <Heading
      as="h2"
      size="md"
      _groupHover={{
        color: 'brand.text',
        textDecoration: 'underline'
      }}
      isTruncated
    >
      {children}
    </Heading>
  )
}

export default CardHeading
